import { render } from "./messageChain.settings.vue?vue&type=template&id=10285a2c"
import script from "./messageChain.settings.vue?vue&type=script&lang=js"
export * from "./messageChain.settings.vue?vue&type=script&lang=js"

import "./messageChain.settings.vue?vue&type=style&index=0&id=10285a2c&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__